<template>
    <div class="relative">
        <div class="container">
            <div class="flex flex-col">
                <div class="w-full mb-14 flex flex-wrap items-center gap-5 | lg:gap-x-9 lg:gap-y-6 | xl:gap-x-7">
                    <span @click="setCategory('all')"
                          class="
                          cursor-pointer block font-semibold py-2.5 px-5 rounded-sm text-darkblue border border-solid border-darkblue-200 transition-colors
                          hover:bg-darkblue hover:shadow-6dp hover:text-white hover:border-darkblue"
                          :class="{'bg-darkblue shadow-6dp text-white border-darkblue' : category === 'all' }"
                    >
                        All entries
                    </span>
                    
                    <span v-for="cat in categories"
                          :key="`blog-category-${cat.name}`"
                          @click="setCategory(cat.name)"
                          class="
                          cursor-pointer block font-semibold py-2.5 px-5 rounded-sm text-darkblue border border-solid border-darkblue-200 transition-colors
                          hover:bg-darkblue hover:shadow-6dp hover:text-white hover:border-darkblue"
                          :class="{'bg-darkblue shadow-6dp text-white border-darkblue' : category === cat.name }"
                    >
                        {{ cat.name }}
                    </span>
                    
                    <span @click="setCategory('Services')"
                          class="
                          cursor-pointer block font-semibold py-2.5 px-5 rounded-sm text-darkblue border border-solid border-darkblue-200 transition-colors
                          hover:bg-darkblue hover:shadow-6dp hover:text-white hover:border-darkblue"
                          :class="{'bg-darkblue shadow-6dp text-white border-darkblue' : category === 'Services' }"
                    >
                        Services
                    </span>
                </div>

                <div class="w-full grid grid-cols-1 gap-y-7 | lg:grid-cols-2 lg:gap-x-5 | xl:grid-cols-3 xl:gap-x-7">
                    <box-post v-for="post in printPosts" :post="post" :key="`blog-post-${post.id}`"></box-post>
                </div>

                <div @click="viewMore"
                     v-show="currentPosts.length > customPostsPerPage"
                     class="cursor-pointer btn btn--secondary block mt-14 mx-auto">
                    <span>See more entries</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import boxPost from "./partials/box-post";

export default {
  name: "blog-posts",
    props: {
        data: [String],
        categories: [Object, Array],
        postsPerPage: [Number, String],
    },
    data() {
      return {
          posts: JSON.parse(this.data),
          category: null,
          customPostsPerPage: parseInt(this.postsPerPage),
          currentPosts: [],
      }
    },
    components: {
        boxPost,
    },
    mounted() {
      this.setCategory('all');
    },
    computed: {
        printPosts() {
            return this.currentPosts.slice(0, this.customPostsPerPage);
        },
    },
    methods: {
      setCategory(cat) {
          this.category = cat;
          this.customPostsPerPage = this.postsPerPage;
          this.currentPosts = this.postsFilter();
      },
      postsFilter() {
          let posts = this.posts;
          
          posts = posts.filter(post => {
              if ( this.category !== 'all' ) {
                  return post.category === this.category;
              }
              else {
                  return post;
              }
          })
          
          return posts;
      },
      viewMore() {
          this.customPostsPerPage += this.postsPerPage;
      },
    },
}
</script>

<style scoped lang="scss">
</style>